import { render, staticRenderFns } from "./VideoCall.vue?vue&type=template&id=00e5a032&scoped=true"
import script from "./VideoCall.vue?vue&type=script&lang=js"
export * from "./VideoCall.vue?vue&type=script&lang=js"
import style0 from "./VideoCall.vue?vue&type=style&index=0&id=00e5a032&prod&lang=scss&scoped=true"
import style1 from "./VideoCall.vue?vue&type=style&index=1&id=00e5a032&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e5a032",
  null
  
)

export default component.exports